import dayjs from "dayjs";
import { getCookie, setCookie } from "base/shared/CookiesHandler";
import { CONVERSATION_ACTION } from "datamodel/Conversation/constants";
import { DAMAGE_COVERAGE_ACTION_COOKIE } from "./constants";

export const isDamageCoverageVisible = (
  action,
  connectionId,
  dmgCoverageEnabled,
) => {
  if (!dmgCoverageEnabled || action !== CONVERSATION_ACTION.INVITE_TO_BOOK) {
    return false;
  }

  const connectionsWithDmgCoverage =
    getCookie(DAMAGE_COVERAGE_ACTION_COOKIE) || [];

  if (
    Array.isArray(connectionsWithDmgCoverage) &&
    connectionsWithDmgCoverage.includes(connectionId)
  ) {
    return false;
  }

  return true;
};

export const activateDamageCoverage = (connectionId) => {
  let connectionsWithDmgCoverage = getCookie(DAMAGE_COVERAGE_ACTION_COOKIE);

  if (Array.isArray(connectionsWithDmgCoverage)) {
    if (connectionsWithDmgCoverage.includes(connectionId)) {
      return;
    }
    connectionsWithDmgCoverage.push(connectionId);
  } else {
    connectionsWithDmgCoverage = [connectionId];
  }

  const expires = dayjs().add(1, "month").toDate();

  setCookie(
    DAMAGE_COVERAGE_ACTION_COOKIE,
    JSON.stringify(connectionsWithDmgCoverage),
    expires,
  );
};
